
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, Badge } from 'antd'
import { API_GET_USER_LOG, API_GET_USER_DOC } from '../../../api'


class Documents extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userDoc: {},
    }
  }

  componentDidMount() {
    this.getUserDoc()
  }

  getUserLog = () => {
    API_GET_USER_LOG(this.props.userId)
      .then((res) => {
        this.setState({ userDoc: res.data })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  getUserDoc = () => {
    API_GET_USER_DOC(this.props.userId)
      .then((res) => {
        const listDocument = res.data.data.filter(x => x.groupCode === 'ktp' || x.groupCode === 'biometric')
        this.setState({ userDoc: listDocument })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  setGroupStatus = (status) => {
    if (status === 'verified') {
      return (<Badge status="success" />)
    } else if (status === 'new') {
      return (<Badge status="default" />)
    } else if (status === 'pending') {
      return (<Badge status="warning" />)
    } else if (status === 'process') {
      return (<Badge status="processing" />)
    }
    return (<Badge status="error" />)
  }

  render() {
    const { userDoc } = this.state

    return (
      <div>
        <Card>
          <div>
            {
              userDoc.length > 0 ?
                userDoc.map((data, i) =>
                (
                  <div key={i}>
                    <h2>{this.setGroupStatus(data.groupStatus)}{data.groupName}</h2>
                    <hr />
                    {data.fields.map((field, i) => (<SetGroupImageAndVoice key={i} data={field} />))}
                  </div>
                ))
              : null
            }
          </div>
        </Card>
      </div>
    )
  }
}

Documents.defaultProps = {
  userId: '',
}

Documents.propTypes = {
  userId: PropTypes.string,
}

export default Documents


const SetGroupImageAndVoice = (props) => {
  const configFieldType = {
    ktp_selfie_url: 'image',
    ktp_url: 'image',
    selfie_url: 'image',
    signature_url: 'signature_url',
    voice_url: 'audio',
  }

  if (!props.data.fieldValue) {
    return <p>Data kosong</p>
  }

  switch (configFieldType[props.data.fieldCode]) {
    case 'image':
      return (
        <div>
          <h4>{props.data.fieldName}</h4>
          <img src={props.data.fieldValue} alt={props.data.fieldName} width={200} />
        </div>
      )
    case 'signature_url':
      return (
        <div>
          <h4>{props.data.fieldName}</h4>
          <img src={props.data.fieldValue} alt={props.data.fieldName} width={200} />
        </div>
      )
    case 'audio':
      return (
        <div>
          <h4>{props.data.fieldName}</h4>
          <audio controls>
            <source src={props.data.fieldValue} type="audio/ogg" />
            <track kind="captions" />
            Your browser does not support the audio element.
          </audio>
        </div>
      )
    default:
      return (
        <p><strong>{props.data.fieldName}</strong> : {props.data.fieldValue}</p>
      )
  }
}



// WEBPACK FOOTER //
// src/pages/user/documents/index.js